import { Fade } from "react-awesome-reveal";
import { withTranslation } from "react-i18next";

import { ContentBlockProps } from "./types";

import {
    PhotoSection,
    ContentHead,
    ContentLocation,
    ContentSublocation,
    VerticalStack,
    ContentText,
    ContentDate,
    StyledRow,
} from "./styles";

const PhotoBlock = ({
    text1,
    location,
    sublocation,
    text2,
    date,
    id,
    direction
}: ContentBlockProps) => {
    return (
        <PhotoSection background="/img/Atlanta.jpg" id={id}>
            <Fade direction={direction} triggerOnce>
                <StyledRow direction={direction}>
                    <VerticalStack>
                        <ContentHead>{text1}</ContentHead>
                        <ContentLocation>{location}</ContentLocation>
                        <ContentSublocation>{sublocation}</ContentSublocation>
                        <ContentText>{text2}</ContentText>
                        <ContentDate>{date}</ContentDate>
                    </VerticalStack>
                </StyledRow>
            </Fade>
        </PhotoSection>
    );
};

export default withTranslation()(PhotoBlock);
